import script from "./Rules.vue?vue&type=script&setup=true&lang=js"
export * from "./Rules.vue?vue&type=script&setup=true&lang=js"

import "./Rules.vue?vue&type=style&index=0&id=5397de52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5397de52"]])

export default __exports__